import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_6 = { class: "badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2" }
const _hoisted_7 = { class: "fw-bold text-muted text-hover-primary fs-7" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_9 = { class: "menu-item px-5" }
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Хэрэглэгчийн мэдээлэл ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_13 = { class: "menu-item px-5" }
const _hoisted_14 = { class: "svg-icon svg-icon-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Гарах ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(this.userdataFromSetup.name2) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(this.userdataFromSetup.username), 1)
          ]),
          _createElementVNode("a", _hoisted_7, _toDisplayString(this.userdataFromSetup.email), 1)
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/user/profile",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Code/Info-circle.svg" })
          ]),
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Interface/Sign-out.svg" })
        ]),
        _hoisted_15
      ])
    ])
  ]))
}